import { Module } from '../Module';
import { LicensingTier, SiteRoleOptionsResource } from '../resources/SiteRoleOptions';

export interface ILicenseTierFilter {
  (licenseTier: LicensingTier): string;
}

Module.instance().filter('licenseTier', [
  '$translate',
  'SiteRoleOptionsResource',
  ($translate: ng.translate.ITranslateService, siteRoleOptionsResource: SiteRoleOptionsResource): ILicenseTierFilter => {
    return (licenseTier: LicensingTier) => {
      return licenseTier ? $translate.instant(siteRoleOptionsResource.getLicenseTierKey(licenseTier)) : '';
    };
  }
]);
